import React from "react"

import { insightAreaItemRequest } from "../../actions/insight-area-actions"

import pageComponent from "../common/page-component-hoc"

import InsightAreaListWidgetContainer from "./insight-area-list/InsightAreaListWidgetContainer"
import InsightAreaFilterWidgetContainer from "./insight-area-filter/InsightAreaFilterWidgetContainer"
import InsightArea from "./insight-area-item/InsightArea"

const InsightAreaComponent = ({ isFilterActive }) => (
    <div className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="topics-list"
        >
            {isFilterActive ? (
                <InsightAreaFilterWidgetContainer />
            ) : (
                <InsightAreaListWidgetContainer />
            )}
        </div>
        <InsightArea />
    </div>
)

export default pageComponent("insightAreas", insightAreaItemRequest)(
    InsightAreaComponent
)
